import cookieCommons from 'common/cookieCommons';
import { useMutation, useQueryClient } from 'react-query';
import { putUserCover } from '../../../apis/profile.api';
import { USER_INFO } from '../../../constant/QueryKeyName';
import useToast from '../../useToast';

const useUpdateCover = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const mutateReturn = useMutation((cover: File) => putUserCover({ cover }), {
    onSuccess() {
      const userId = cookieCommons.getQbankUserId();
      if (userId) {
        queryClient.refetchQueries([USER_INFO, userId], { active: true });
        toast('Cập nhật thành công.', 'success');
      }
    },
    onError() {
      toast('Có lỗi xảy ra, vui lòng thử lại sau.', 'error');
    },
  });

  return { mutateReturn };
};

export default useUpdateCover;
